import React, { useEffect, useRef, useState } from 'react';
import { shouldAnimate } from '../../utils/motion';

function FaqItem({ item, index, open, onToggle }) {
  const answerRef = useRef(null);
  const [height, setHeight] = useState(open ? 'auto' : 0);
  const first = useRef(true);

  useEffect(() => {
    const element = answerRef.current;
    if (!element) return undefined;
    if (first.current || !shouldAnimate()) {
      first.current = false;
      setHeight(open ? 'auto' : 0);
      return undefined;
    }

    // Animate between a measured pixel height and auto/0.
    const full = element.scrollHeight;
    if (open) {
      setHeight(full);
      const timer = window.setTimeout(() => setHeight('auto'), 400);
      return () => window.clearTimeout(timer);
    }
    setHeight(full);
    const frame = window.requestAnimationFrame(() => setHeight(0));
    return () => window.cancelAnimationFrame(frame);
  }, [open]);

  return (
    <article className={`home-faq-item ${open ? 'is-open' : ''}`}>
      <button
        type="button"
        className="home-faq-question"
        aria-expanded={open}
        aria-controls={`home-faq-answer-${index}`}
        id={`home-faq-question-${index}`}
        onClick={onToggle}
      >
        <span>{item.question}</span>
        <span className="home-faq-icon" aria-hidden="true">+</span>
      </button>
      <div
        ref={answerRef}
        className="home-faq-answer"
        id={`home-faq-answer-${index}`}
        role="region"
        aria-labelledby={`home-faq-question-${index}`}
        style={{ height: height === 'auto' ? 'auto' : `${height}px` }}
      >
        <p>{item.answer}</p>
      </div>
    </article>
  );
}

export default function HomeFaq({ items }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="home-faq">
      {items.map((item, index) => (
        <FaqItem
          key={item.question}
          item={item}
          index={index}
          open={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
        />
      ))}
    </div>
  );
}
